import React from "react";
import { Loading, LoadingDiv } from "./style";

export const LoadingComponent:React.FC = () => {
  return(
    <Loading>
      <LoadingDiv>
        <div></div>
      </LoadingDiv>
    </Loading>
  )
}

export default LoadingComponent